webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Garage__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Garage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Garage__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Garage',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Garage___default.a
  }]
}));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(13)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(23),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app'
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProjectList_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProjectList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProjectList_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Garage',
    components: {
        ProjectList: __WEBPACK_IMPORTED_MODULE_0__ProjectList_vue___default.a
    }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProjectItem',
    props: ['project'],
    data: function data() {
        return {
            hover: false
        };
    },

    computed: {
        projectNameKebab: function projectNameKebab() {
            if (this.hover) {
                return this.project['name'].toLowerCase().replace(/ +/g, '-');
            }
            return this.project['name'];
        }
    }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProjectItem_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProjectItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProjectItem_vue__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProjectList',
    data: function data() {
        return {
            projects: []
        };
    },
    mounted: function mounted() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            var vm = this;
            var xhr = new XMLHttpRequest();
            xhr.open('GET', '/static/garage.json');
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                    var res = JSON.parse(xhr.responseText);
                    vm.projects = res.projects;
                }
            };
            xhr.send();
        }
    },
    components: {
        ProjectItem: __WEBPACK_IMPORTED_MODULE_0__ProjectItem_vue___default.a
    }
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(10)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(20),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(11)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(21),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(22),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "garage-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "project-list-container"
  }, [_c('project-list')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "garage-fancy monospaced"
  }, [_c('p', [_vm._v("~ $ cd garage")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("~/garage $ cat README.md")]), _vm._v(" "), _c('p', [_vm._v("\n         - Here in my garage, just got this new "), _c('del', [_vm._v("Lamborghini")]), _vm._v("project here. \n         (It’s) fun to drive up here in the "), _c('del', [_vm._v("Hollywood")]), _vm._v("Torrey Pines hills.\n         ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("~/garage $ ./draw-a-frog")]), _vm._v(" "), _c('p', {
    staticClass: "asciiart"
  }, [_vm._v("\n  @..@        \n (\\--/)      \n(.>__<.)               \n^^^  ^^^ \n         ")]), _vm._v(" "), _c('p', [_vm._v("~/garage $ "), _c('span', {
    staticClass: "blinking-cursor"
  }, [_vm._v("_")])])])
}]}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nostyle",
    attrs: {
      "href": _vm.project['link'],
      "target": _vm.project['link'] ? '_blank' : null
    }
  }, [_c('div', {
    staticClass: "project",
    on: {
      "mouseenter": function($event) {
        _vm.hover = true
      },
      "mouseleave": function($event) {
        _vm.hover = false
      }
    }
  }, [_c('div', {
    staticClass: "project-image"
  }, [(_vm.project['image']) ? _c('img', {
    attrs: {
      "src": _vm.project['image']
    }
  }) : (_vm.project['image_initial']) ? _c('span', {
    staticClass: "monospaced"
  }, [_vm._v("\n                " + _vm._s(_vm.project['image_initial']) + "\n            ")]) : _c('span', {
    staticClass: "monospaced"
  }, [_vm._v("\n                " + _vm._s(_vm.project['name'][0]) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "project-description"
  }, [_c('h3', {
    staticClass: "monospaced"
  }, [_vm._v(_vm._s(_vm.projectNameKebab))]), _vm._v(" "), _vm._l((_vm.project['description']), function(line) {
    return _c('p', [_vm._v(_vm._s(line))])
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-list"
  }, [_c('h3', {
    staticClass: "monospaced"
  }, [_vm._v("$ ls -la ↵")]), _vm._v(" "), _vm._l((_vm.projects), function(p) {
    return _c('project-item', {
      key: p.name,
      attrs: {
        "project": p
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('main', [_c('router-view')], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('span', {
    staticClass: "monospaced"
  }, [_vm._v("~ $ ./garage")]), _vm._v(" "), _c('span', {
    staticClass: "monospaced blinking-cursor"
  }, [_vm._v("_")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('span', {
    staticClass: "monospaced"
  }, [_vm._v("[Process finished with exit code 0]")])])
}]}

/***/ })
],[5]);


// WEBPACK FOOTER //
// static/js/app.1ceddee32d9e69354bf5.js